import dayjs from "dayjs";
import "dayjs/locale/es";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";

dayjs.extend(updateLocale);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime, {
  thresholds: [
    { l: "s", r: 1 },
    { l: "m", r: 1 },
    { l: "mm", r: 59, d: "minute" },
    { l: "h", r: 1 },
    { l: "hh", r: 23, d: "hour" },
    { l: "d", r: 1 },
    { l: "dd", r: 29, d: "day" },
    { l: "M", r: 1 },
    { l: "MM", r: 11, d: "month" },
    { l: "y", r: 1 },
    { l: "yy", d: "year" },
  ],
});

dayjs.updateLocale("es", {
  relativeTime: {
    future: "en %s",
    past: "hace %s",
    s: "unos segundos",
    m: "un minuto",
    mm: "%d minutos",
    h: "una hora",
    hh: "%d horas",
    d: "un día",
    dd: "%d días",
    M: "un mes",
    MM: "%d meses",
    y: "un año",
    yy: "%d años",
  },
});

export const formatDateRelativeTo = (
  date?: string | Date | null,
  config?: { lng?: string },
) => {
  const { lng = "es" } = config ?? {};
  if (!date) return "";

  return dayjs().locale(lng).to(dayjs(date));
};

export const formatDate = (
  date?: string | Date | null,
  config?: { format?: string; lng?: string; timeZone?: string },
) => {
  const { format, lng = "es", timeZone } = config ?? {};

  if (!date) return "";
  const moment = timeZone ? dayjs(date).tz(timeZone) : dayjs(date);
  return moment.locale(lng).format(format);
};
